import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { LayoutFullWidthRenderComponent } from './layout-full-width-render.component';


export const components = [
  LayoutFullWidthRenderComponent
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule
  ],
  declarations: components
})
export class LayoutFullWidthRenderModule {}

export default components;
